import React from "react";

// What to show when a list has nothing yet: what the space is for and what to do next.
export default function EmptyState({ icon: Icon, title, description, action, className = "", ...props }) {
  return (
    <div className={`flex flex-col items-center px-4 py-12 text-center ${className}`} {...props}>
      {Icon && <span className="icon-tile mb-3 h-12 w-12" aria-hidden="true"><Icon className="h-6 w-6" /></span>}
      <p className="font-semibold">{title}</p>
      {description && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
